import CardPostagem from "../ViewPostagem/components/Card";
import { Container } from "./styles";

export default function ViewPostagem() {
  return (
    <Container>
      <CardPostagem />
    </Container>
  );
}
